import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class ResendRegisterEmail extends Event {
    eventName = 'oms_resendRegisterEmail';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Validate Discount Code
     * 
     * @param {string} data.discount_code -  discount code
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let id = data.id;

        if (clientId && id) {

            // request data
            data.endPoint = application_settings.endPoints.ResendEmail;
            data.method = 'POST';
            data.multi_call_key = (data.multi_call_key) ? data.multi_call_key : 'resned_email';
            data.data = {
                client_id: clientId,
                id: id
            };
        
            // send request
            this.sendRequest(data, function (response) {
              if (response) {
                let data = thisObj.formatResponseData(response);
                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default ResendRegisterEmail;